
export default {
    name: 'SvgBrakes',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
    },
};
